import { Component } from "react";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
    this.retry = this.retry.bind(this);
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("Song of Madness — erro capturado:", error, info?.componentStack);
  }

  componentDidUpdate(prevProps) {
    if (this.state.error && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ error: null });
    }
  }

  retry() {
    this.setState({ error: null });
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="veil-error" role="alert">
        <div className="veil-error-mark" aria-hidden="true">✦</div>
        <h1>Algo se perdeu no véu.</h1>
        <p>Uma runa quebrou-se a meio da invocação. Podes tentar reabrir o arquivo ou recarregar a página.</p>
        <div className="veil-error-actions">
          <button type="button" onClick={() => window.location.reload()}>Recarregar página</button>
          <button type="button" className="ghost" onClick={this.retry}>Tentar continuar</button>
        </div>
      </div>
    );
  }
}
